var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"graph",staticClass:"card mt-4"},[_c('div',{staticClass:"card-body"},[_c('h3',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.graphName))]),_vm._v(" "),_c('h4',[_vm._v("Equation: y= "+_vm._s(_vm.equation))]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.graphDescription))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fcc75f3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Graph.vue
// module id = 118
// module chunks = 0